import { Observable } from "rxjs";
import { AuthService } from "./services/auth.service";

export function authInitializerFactory(
  authService: AuthService
): () => Observable<void> {
  return () => authService.initialize();
}
